import { TrophyOutlined } from '@ant-design/icons-vue';
import LevelSetting from '@/views/levels/LevelSetting.vue';
import LevelLog from '@/views/levels/LevelLog.vue';

export const levelsFolderRoute = {
    path: 'levels',
    name: 'Levels',
    redirect: '/levels/level-setting',
    meta: {
        title: '等級管理',
        icon: TrophyOutlined
    },
    children: []
};

export const levelsChildrenRoutes = [
    {
        path: 'level-setting',
        component: LevelSetting,
        name: 'LevelSetting',
        meta: {
            title: '等級設置'
        }
    },
    {
        path: 'level-log',
        component: LevelLog,
        name: 'LevelLog',
        meta: {
            title: '等級紀錄'
        }
    }
];
